export const dynamic = 'force-dynamic';
import { FC } from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';

import { dates } from '@/shared/utils/dates';
import { numbers } from '@/shared/utils/numbers';

import { initFonts } from '../LastWillPDF/helpers';

import { VideoCertificatePDFProps } from './types';

import { styles } from './styles';

initFonts();

export const VideoCertificatePDF: FC<VideoCertificatePDFProps> = ({
  date,
  fullName,
  willNumber,
  videoData,
  attachmentNumber,
}) => {
  const data = [
    {
      field: 'Field',
      value: 'Value',
    },
    {
      field: 'Will number',
      value: willNumber,
    },
    {
      field: 'Filename',
      value: videoData.filePath,
    },
    {
      field: 'File size',
      value: numbers.formatMemoryFromBytes(videoData.fileSizeBytes),
    },
    {
      field: 'Hash',
      value: videoData.hash,
    },
    {
      field: 'Duration',
      value: dates.formatSecondsToMmSs(videoData.durationSeconds),
    },
    {
      field: 'Resolution',
      value: videoData.resolution,
    },
    {
      field: 'Frame rate',
      value: videoData.frameRate,
    },
    {
      field: 'Video codec',
      value: videoData.videoCodec,
    },
    {
      field: 'Audio available',
      value: videoData.hasAudio ? 'Yes' : 'No',
    },
    {
      field: 'Audio codec',
      value: videoData.audioCodec,
    },
    {
      field: 'Recording start',
      value: videoData.recordingStartedAt
        ? dates.formatDateTimeInterwill(new Date(videoData.recordingStartedAt))
        : 'Unknown',
    },
    {
      field: 'Recording end',
      value: videoData.recordingEndedAt
        ? dates.formatDateTimeInterwill(new Date(videoData.recordingEndedAt))
        : 'Unknown',
    },
    {
      field: 'Profile ID',
      value: videoData.profileId,
    },
  ];

  return (
    <Document style={styles.document}>
      <Page size={{ width: 794, height: 1056 }} style={styles.page} break={false} wrap={false}>
        <View style={styles.watermark}>
          <Text wrap={false} break={false}>
            LAST WILL AND TESTAMENT of {fullName}
          </Text>
        </View>

        <View style={styles.header}>
          <Text>{dates.formatDate(date)}</Text>

          <Text>Last Will and Testament of {fullName}</Text>
          <Text>
            Number <Text>{willNumber}</Text>
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.title}>VIDEO VERIFICATION CERTIFICATE</Text>
          <Text>Certificate Number: {attachmentNumber}</Text>
          <Text>Date of issue: {dates.formatDateTimeInterwill(videoData.createdAt)}</Text>
          <Text>Signed with X.509 certificate Owner.One video signing CA</Text>

          {data.map((item) => (
            <View style={styles.row} key={item.field}>
              <View style={styles.border}>
                <Text>{item.field}</Text>
              </View>
              <View style={styles.border}>
                <Text
                  hyphenationCallback={(chunk) => {
                    return chunk.match(/.{1,20}/g) ?? [chunk];
                  }}
                >
                  {item.value}
                </Text>
              </View>
            </View>
          ))}

          <View style={styles.spacer} />
          <Text>Cryptographic signature:</Text>

          <View style={styles.row}>
            <View style={styles.border}>
              <Text>Signature</Text>
            </View>
            <View style={styles.border}>
              <Text>certificate.json | base64 -D {'>'} sig.bin</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.border}>
              <Text>Signing certificate</Text>
            </View>
            <View style={styles.border}>
              <Text>certificate.json {'>'} cert.pem</Text>
            </View>
          </View>
        </View>

        <View style={styles.footer} fixed>
          <View fixed>
            <Text>Powered by the International Will by the Owner.One Repository</Text>
          </View>
        </View>
      </Page>

      <Page size={{ width: 794, height: 1056 }} style={styles.page} break={false} wrap={false}>
        <View style={styles.watermark}>
          <Text wrap={false} break={false}>
            LAST WILL AND TESTAMENT of {fullName}
          </Text>
        </View>

        <View style={styles.header}>
          <Text>{dates.formatDate(date)}</Text>

          <Text>Last Will and Testament of {fullName}</Text>
          <Text>
            Number <Text>{willNumber}</Text>
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.title}>VIDEO VERIFICATION CERTIFICATE</Text>
          <Text style={styles.json}>{JSON.stringify(videoData, undefined, 4)}</Text>
        </View>

        <View style={styles.footer} fixed>
          <View fixed>
            <Text>Powered by the International Will by the Owner.One Repository</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};
